import { mapGetters, mapMutations, mapActions } from 'vuex';
import mvtSelect from '@/common/components/mvtselect/mvt-select.vue';
import mvtTextbox from '@/common/components/mvttextbox/mvt-textbox.vue';
import mvtInputNumber from '@/common/components/mvtinputnumber/mvt-inputnumber.vue';
import mvtRadio from '@/common/components/mvtradio/mvt-radio.vue';
import mvtInputDecimalNumber from '@/common/components/mvtinputdecimalnumber/mvt-inputdecimalnumber.vue';
import mvtShifter from '@/common/components/mvtshifter/mvt-shifter.vue';
import mvtCardMortgage from '@/common/components/mvtcardmortgage/mvt-cardmortgage.vue';
import mvtInputInt from '@/common/components/mvtinputint/mvt-inputint.vue';
import format from '@/common/utilities/format';
import motime from '@/common/utilities/motime';
import propertyFuncs from '@/common/utilities/propertyFuncs';
import additionalServices from './additionalservices/additional-services.vue';
import internetcableProvider from './internetcableprovider/internetcable-provider.vue';
import bankrateFooter from './bankratefooter/bankrate-footer.vue';
import mvtLazyload from '@/common/components/mvtlazyload/mvt-lazyload.vue';
import { getMonthPay, taxRateByState } from '../../../common/utilities/monthpay';
import { resolveClickCta } from '@/common/utilities/nojq/_utilities.js';
//get year from date
const year = new Date().getFullYear();
export default {
    name: 'propertyMortgage',
    props: [
        'state',
        'daysOnMovoto',
        'price',
        'yearBuilt',
        'hoafee',
        'zipcode',
        'address',
        'subPremise',
        'propertyType',
        'city',
        'isActive',
        'houseRealStatus',
        'isOjOBrokerage',
        'loadBankrateLink',
        'pid',
        'propertyId',
        'path',
        'showCPC',
        'showRefinance',
        'showCheckScore',
        'triggerId',
        'cta',
        'showDataSource',
    ],
    inject: ['$eventBus', 'split'],
    components: {
        mvtSelect,
        mvtRadio,
        mvtTextbox,
        mvtInputNumber,
        mvtInputDecimalNumber,
        mvtInputInt,
        mvtShifter,
        mvtCardMortgage,
        additionalServices,
        internetcableProvider,
        bankrateFooter,
        mvtLazyload,
    },
    computed: {
        ...mapGetters('glb', ['glb', 'getMortgageOptionsData', 'getSplit']),
        ...mapGetters('dpp', ['dpp', 'getEstPrice']),
        isMobilePropertySplit() {
            return ['MOBILE'].includes(this.dpp.propertyType);
        },
        cordlessLoaded() {
            return this.isCordlessLoaded;
        },
        sortedMortgageResult() {
            if (this.mortgageResult) {
                return this.mortgageResult.sort(function (a, b) {
                    const sortValueFirst = (a.estpayment && a.estpayment * 1) || 0;
                    const sortValueSecond = (b.estpayment && b.estpayment * 1) || 0;
                    return sortValueFirst - sortValueSecond;
                });
            }
            return [];
        },
        isReduceCTASplit() {
            return this.isActive;
        },
        topVeteran() {
            if (this.showBankrateVeteranTop) {
                return {
                    cta: this.molang('dpp.propertyMortgage.veteransEligibility'),
                    id: 'veteranseligibility',
                };
            } else if (this.getSplit('movoto-vu-veteran-top-CW-9812', 'on14')) {
                return {
                    cta: `Veterans: Check ${year} VA Loan Requirements`,
                    id: 'lower_veteran_top',
                };
            } else if (this.getSplit('movoto-vu-veteran-top-CW-9812', 'on1')) {
                return {
                    cta: `Veterans: Check ${year} VA Loan Requirements`,
                    id: 'veteranseligibility1',
                };
            } else if (this.getSplit('movoto-vu-veteran-top-CW-9812', 'on2')) {
                return {
                    cta: `0% Down for Veterans: Check ${year} Eligibility`,
                    id: 'veteranseligibility2',
                };
            } else if (this.getSplit('movoto-vu-veteran-top-CW-9812', 'off')) {
                return {
                    cta: 'Veterans: Unlock Homebuying Superpowers',
                    id: 'veteranseligibility3',
                };
            }
            return null;
        },
        bottomVeteran() {
            if (this.showBankrateVeteranBottom) {
                return {
                    cta: this.molang('dpp.propertyMortgage.veteransCanAfford'),
                    id: 'veteranscanafford4',
                };
            }
            if (this.getSplit('movoto-vu-veteran-bottom-CW-9813', 'on')) {
                return {
                    cta: `${year} VA Loans: Check Eligibility & Rates`,
                    id: 'ventran_bottom',
                };
            } else if (this.getSplit('movoto-vu-veteran-bottom-CW-9813', 'on14')) {
                return {
                    cta: `Veterans: See what you can afford in ${year}`,
                    id: 'lower_veteran_bottom',
                };
            } else if (this.getSplit('movoto-vu-veteran-bottom-CW-9813', 'on1')) {
                return {
                    cta: `Veterans: See what you can afford in ${year}`,
                    id: 'veteranscanafford6',
                };
            } else if (this.getSplit('movoto-vu-veteran-bottom-CW-9813', 'off')) {
                return {
                    cta: `Veterans: See what you can afford in ${year}`,
                    id: 'veteranscanafford3',
                };
            }
            return null;
        },
        isBankRate() {
            return this.mortgageResult && this.mortgageResult[0] && this.mortgageResult[0].feesRaw;
        },
        insuranceLink() {
            return this.glb.appUrl + 'insurance/?zipcode=' + this.zipcode;
        },
        pricePerMonth() {
            let internetPerMonth = !this.dpp.isRentals ? 50 : 0;
            return this.homeInsurancePerMonth + this.pmiPerMonth + this.hoaPerMonth + this.taxPerMonth + this.loanPerMonth + internetPerMonth;
        },
        interestOption() {
            return this.interestRateList[this.interestRateIndex];
        },
        providerNameForMR() {
            return this.providerName;
        },
        chartData() {
            var data = [];
            if (this.loanPerMonth > 0) {
                data.push({
                    key: 'Interest',
                    className: 'interest',
                    price: this.loanPerMonth,
                    value: Math.ceil((this.loanPerMonth / this.pricePerMonth) * 100) + '%',
                });
            }
            if (this.taxPerMonth > 0) {
                data.push({
                    key: 'Taxes',
                    className: 'tax',
                    price: this.taxPerMonth,
                    value: ((this.taxPerMonth / this.pricePerMonth) * 100).toFixed(0) + '%',
                });
            }
            if (this.homeInsurancePerMonth > 0) {
                data.push({
                    key: 'Insurance',
                    className: 'insurance',
                    price: this.homeInsurancePerMonth,
                    value: ((this.homeInsurancePerMonth / this.pricePerMonth) * 100).toFixed(0) + '%',
                });
            }
            if (this.pmiPerMonth > 0) {
                data.push({
                    key: 'PMI',
                    className: 'pmi',
                    price: this.pmiPerMonth,
                    value: ((this.pmiPerMonth / this.pricePerMonth) * 100).toFixed(0) + '%',
                });
            }
            if (this.hoaPerMonth > 0) {
                data.push({
                    key: 'HOA',
                    className: 'hoa',
                    price: this.hoaPerMonth,
                    value: ((this.hoaPerMonth / this.pricePerMonth) * 100).toFixed(0) + '%',
                });
            }
            if (this.internetCableMonthly) {
                data.push({
                    key: 'IAC',
                    className: 'iac',
                    price: this.internetCableMonthly,
                    value: ((this.internetCableMonthly / this.pricePerMonth) * 100).toFixed(0) + '%',
                });
            }
            return data;
        },
        mortgageOptions() {
            return {
                pid: this.pid || `movoto_${this.glb.pageType}`,
                state: this.state,
                city: encodeURIComponent(this.city),
                zip: this.zipcode,
                price: this.price,
                loanAmount: this.loanAmount,
                loanType: this.isActive ? 'purchase' : 'refinance',
                propertyType: this.propertyType,
                status: this.houseRealStatus,
                period: this.interestOption && this.interestOption.period,
                ltv: Math.round((100 * (this.homePrice - this.downpayment - this.downpaymentEquity)) / this.homePrice),
                fico: this.credit,
            };
        },
        prequalifyObj() {
            var betterLink = this.glb.geo.state === 'NY';
            const obj = {
                cta: this.isActive ? this.molang('dpp.propertyMortgage.prequalifyHere') : this.molang('dpp.propertyMortgage.refinance'),
                utmcta: this.isActive ? 'prequalify' : 'refinance',
                url: this.isActive ? (betterLink ? 'betterpreapproved' : 'preapprove') : 'refinance',
            };
            return obj;
        },
        principalInterestObj() {
            const obj = {
                cta: this.isActive ? this.molang('dpp.propertyMortgage.findLender') : this.molang('dpp.propertyDetails.getLowerPayment'),
                utmcta: 'findalender',
                url: 'preapprove',
            };
            return obj;
        },
        hideLenderButton() {
            const mortgageCTAbelow100K =
                this.dpp.houseRealStatus === 'ACTIVE' && this.dpp.price >= 50000 && this.dpp.price < 100000 && ['SINGLE_FAMILY_HOUSE', 'CONDO'].includes(this.dpp.propertyType);
            if (this.isMobilePropertySplit || mortgageCTAbelow100K) {
                return false;
            }
            if (this.price < 100000 || ['LAND', 'MOBILE'].includes(this.propertyType)) {
                return true;
            }
            return false;
        },
        hideApprovalButton() {
            let dpp = { price: this.price, propertyType: this.propertyType };
            if (this.isMobilePropertySplit) {
                return false;
            }
            return propertyFuncs.isMinorProperty(dpp);
        },
        showAdditionalServices() {
            return ['ACTIVE', 'OFF_MARKET', 'SOLD', 'PENDING'].includes(this.houseRealStatus);
        },
        creditTextButton() {
            const priceLessThan100k = this.price < 100000;
            const isActive = this.houseRealStatus === 'ACTIVE';
            return priceLessThan100k && isActive;
        },
        cpc3wayPayment() {
            return !this.showCPC;
        },
        showBankrateVeteranBottom() {
            const price = this.price < 200000 && this.price > 100000;
            const status = !['MOBILE', 'LAND'].includes(this.houseRealStatus);
            return price && status;
        },
        showBankrateVeteranTop() {
            const price = this.price < 249999 && this.price >= 100000;
            const status = !['MOBILE', 'LAND'].includes(this.houseRealStatus);
            return price && status;
        },
    },
    watch: {
        loanPerMonth(newVal, oldVal) {
            this.$emit('loanPerMonthChanged', this.loanPerMonth);
        },
        monthTotal(newVal, oldVal) {
            this.$emit('monthTotalChanged', this.monthTotal);
        },
        getEstPrice() {
            if (this.showEstPrice()) {
                this.reset();
            }
        },
        mortgageOptions(newVal, oldVal) {
            this.hasChanged = true;
            if (this.showRefinance) {
                this.mortgageResult = [];
                this.updateMortgageResult();
            }
            if (this.openMorgage && !this.getSplit('movoto-dpp-mortgagesec-open-cw-803', 'on')) {
                this.openMorgage = false;
                this.mortgageResult = [];
            }
        },
        openMorgage() {
            if (this.openMorgage && this.hasChanged) {
                this.$eventBus.$emit('ga', { ec: 'partner_mortgage_dpprate_sessions' });
                this.external = 'dppratecards';
                this.rateLocation = 'Listings Rate Cards';
                this.updateMortgageResult();
            }
        },
    },
    mounted() {
        var that = this;
        if (this.showRefinance) {
            this.credit = 740;
        }
        $(this.$el)
            .find('[data-role="toggle"]')
            .on('click', function () {
                $(this).parent().toggleClass('shown');
                let key = this.dataset.id;
                if (key) {
                    let isActive = $(this).parent().is('.shown');
                    that.updatePaymentSectionValues(key, isActive);
                }
            });
        this.fetchCachedMortgageRates().then((res) => {
            if (res && res.data) {
                this.updatedMortgateInterestRates = res.data;
            }
            this.updateInterstRate();
        });
        if (this.getMortgageOptionsData) {
            // value initialization
            this.creditList = this.getMortgageOptionsData.creditList || [];
            this.interestRateList = this.getMortgageOptionsData.interestRateList || [];
        }
        if (this.glb.enableThirdPart && !this.glb.isSSR) {
            fetch('https://widgets.icanbuy.com/DisclaimerAPI.aspx')
                .then((response) => response.text())
                .then((str) => new window.DOMParser().parseFromString(str, 'text/xml'))
                .then((xmlDoc) => {
                    const disclaimer = xmlDoc.querySelector('disclaimertext').textContent;
                    this.disclaimerHtml = disclaimer.replace(/<script[^>]*>.*?<\/script>/g, '');
                });
        }
        this.reset();
        this.updateOjoLink({
            zipcode: this.zipcode,
            price: this.price,
            city: this.city,
            state: this.state,
            address: this.address,
        });
        this.initializeSections();
        this.$eventBus.$on('eventbus-open-mortgage', function (data) {
            that.openMorgage = data.openMorgageFlag;
        });
        if (this.isMobilePropertySplit) {
            this.$eventBus.$emit('ga', {
                ec: 'embeddedcalc_mobile',
                en: 'partner_mortgage_listings_session_mobile',
                el: 'CalcPaymentUI_mobile',
                props: { link_name: 'Calculate your monthly payment with a lender' },
            });
        } else if (this.showCPC) {
            this.$eventBus.$emit('ga', {
                ec: 'partner_mortgage_listings_session_calcpayment',
                en: 'embeddedcalc',
                el: 'CalcPaymentUI',
                props: { link_name: 'Calculate your monthly payment with a lender' },
            });
        }
        this.$eventBus.$on('expand-iacp', function () {
            !that.openIACProvider && that.toogleIACProvider();
        });

        this.$eventBus.$on('eventbus-dialog-close', function () {
            var sectionDiv = document.getElementById('dppMortgageSection');
            if (that.dppRateSectionWidget && !sectionDiv.hasChildNodes()) {
                sectionDiv.appendChild(that.dppRateSectionWidget);
            }
        });
    },
    data() {
        return {
            showAll: false,
            shouldGaTrigger_10250_on1: true,
            updatedMortgateInterestRates: null,
            hasChanged: false,
            mortgageRateSubHeader: `Rates Published ${motime.formatDate(new Date())} for ${this.address}`,
            ltv: 0,
            openMorgage: false,
            openIACProvider: false,
            mortgageRatesLoaded: false,
            isCordlessLoaded: false,
            interestRate: 0,
            interestRateIndex: 0,
            homePrice: 0,
            loanAmount: 0,
            homeInsurance: 0,
            homeInsurancePerMonth: 0,
            hasHomeInsurance: true,
            pmiPerMonth: 0,
            hoaPerMonth: 0,
            hasHOADues: true,
            taxPerMonth: 0,
            loanPerMonth: 0,
            downpayment: 0,
            downpaymentEquity: 0,
            emitEquityInput: true,
            downpaymentRate: 25,
            propertyTax: 0,
            propertyTaxRate: 0,
            hasPropertyTax: true,
            hasDPChanged: false,
            hasTaxValChanged: false,
            propertyHoafee: 0,
            monthTotal: 0,
            mortgageResult: [],
            credit: 740,
            creditList: [],
            disclaimerHtml: '',
            interestRateList: [],
            providerName: '',
            external: '',
            rateLocation: '',
            dppRateSectionWidget: null,
            internetCableMonthly: 50,
            informaDisclaimer: '',
            informaDisclosureContent: '',
        };
    },
    methods: {
        ...mapActions('glb', ['getMortgageInfo', 'fetchCachedMortgageRates']),
        ...mapMutations('glb', ['updateOjoLink']),
        completed() {
            this.$refs.lazyload && this.$refs.lazyload.ready();
        },
        toogleLink() {
            this.showAll = !this.showAll;
        },
        toogleResult() {
            this.toggleMortgageSection(!this.openMorgage);
        },
        toggleMortgageSection(value) {
            if (this.openMorgage != value) {
                this.openMorgage = !this.openMorgage;
                this.updatePaymentSectionValues('mortgage', this.openMorgage);
            }
        },
        toogleIACProvider() {
            this.openIACProvider = !this.openIACProvider;
            if (this.openIACProvider) {
                this.$eventBus.$emit('initialize-iacp-service');
            }
        },
        openCreditScoreLink() {
            if (this.glb.isSSR) {
                return;
            }
            let url = 'https://links.cordlessmedia.com/staticlink/89984/89984_textLink_07/textLink/credit';
            let el = 'cordless';
            window.open(url, '_blank');
            this.$eventBus.$emit('ga', { ec: 'partner', en: 'credit_monitoring_session', el, props: { link_name: 'ratestyp' } });
        },
        openInsProvider() {
            if (this.glb.isSSR) {
                return;
            }
            if (this.glb.pageType === 'vdpp') {
                this.$eventBus.$emit('ga', { ec: 'partner', en: 'insurance_session', el: 'insurify', props: { link_name: 'findinsuranceprovider_dpp' } });
                window.open('https://insurify.com/start/home/partner/ojo/?utm_source=ojo&utm_medium=home&utm_campaign=findprovider', '_blank');
                return;
            }
            let url =
                'https://quotes.insure.com/homeinsurance.html?version=v2&src=662474&CCID=20409392204662412&QTR=ZZf201903040955300Za20409392Zg255Zw0Zm0Zc204662412Zs21722ZZ&CLK=626220526160921370&&zip=92691&AFF=98bfbbfa2a75ed39e991d94df2bee4c1&source=InsureAdv&&exp=y';
            this.$eventBus.$emit('ga', { ec: 'partner', en: 'insurance_session', el: 'cordless', props: { link_name: 'findinsuranceprovider_dpp' } });
            window.open(url, '_blank');
        },
        updateMortgageResult() {
            //those code will not be working since the 9238 9240 9242 be applied as client side split the treatment has no value before user click the button
            //if cause any issue, we need change the split back to server side split
            //this.checkSplitForMortgage();
            this.invokeInforma();
        },
        checkSplitForMortgage() {
            const splitsTreatment = [
                {
                    dTarget: 'listingsmovotoapi',
                    trigger: 'compareMortRates',
                    external: 'comparemortgagerates',
                },
                {
                    split: 'movoto-cpc-apply-cw-9238',
                    treatment: 'on3',
                    trigger: 'apply',
                    dTarget: 'listingsmovotoapi',
                    external: 'apply',
                    location: 'Listings Clicks',
                    cta: 'Get Preapproved',
                },
                {
                    split: 'movoto-cpc-preapproved-cw-9240',
                    treatment: 'on4',
                    trigger: 'getpreapproved',
                    dTarget: 'listingsmovotoapi',
                    external: 'getpreapproved',
                    location: 'Listings Clicks',
                },
                {
                    split: 'movoto-cpc-preapproved-cw-9240',
                    treatment: 'on4',
                    trigger: 'calcfindalender',
                    dTarget: 'listingsmovotoapi',
                    external: 'getpreapproved',
                    location: 'Listings Clicks',
                },
                {
                    split: 'movoto-cpc-lender-cw-9242',
                    treatment: 'on4',
                    trigger: 'findalender',
                    dTarget: 'listingsmovotoapi',
                    external: 'findalender',
                    location: 'Listings Clicks',
                },
                {
                    split: 'movoto-mortgage-CW-10250',
                    treatment: 'on1',
                    trigger: 'postremovotoapi',
                    dTarget: 'postremovotoapi',
                    external: 'postRE',
                    location: 'Post Lead Submission Rate Cards',
                },
            ];
            if (this.external) {
                this.mortgageOptions.external = this.external;
            }
            splitsTreatment.find((item) => {
                if (this.triggerId === item.trigger && (this.triggerId === 'compareMortRates' || this.getSplit(item.split, item.treatment) || this.getSplit(item.split, 'default'))) {
                    this.mortgageOptions.newDisplayTargets = item.dTarget;
                    this.mortgageOptions.external = item.external;
                    if (item.location) {
                        this.rateLocation = item.location;
                    }
                    if (this.triggerId === 'postremovotoapi') {
                        this.shouldGaTrigger_10250_on1 && this.$eventBus.$emit('ga', { ec: 'partner_mortgage_postre_session', en: 'rates_ui' });
                        this.shouldGaTrigger_10250_on1 = false;
                    } else if (this.triggerId === 'refimovotoapi') {
                        this.$eventBus.$emit('ga', { ec: 'partner_mortgage_refinance_sessions', en: 'rates_ui', props: { link_name: this.cta } });
                    } else {
                        this.$eventBus.$emit('ga', { ec: 'partner_mortgage_listings_session', en: 'rates_ui', props: { link_name: item.cta || this.cta } });
                    }
                    return true;
                }
            });
        },
        invokeInforma() {
            var that = this;
            if (!this.mortgageOptions.newDisplayTargets && this.showCheckScore) {
                this.mortgageOptions.newDisplayTargets = 'postremovotoapi';
            }
            if (this.triggerId === 'compareMortRates') {
                this.mortgageOptions.external = 'comparemortgagerates';
            }
            this.getMortgageInfo(this.mortgageOptions).then(function (response) {
                let result = [];
                that.providerName = 'Informa Rate';
                if (response) {
                    result = response.rates || [];
                    that.informaDisclaimer = response.disclaimerHtml;
                    that.informaDisclosureContent = response.advertiserDisclosure;
                }
                // if no result -20 and try again.
                if (result && result.length) {
                    that.mortgageRatesLoaded = true;
                    that.mortgageResult = result || [];
                    that.hasChanged = false;
                    that.completed();
                    if (that.isBankRate) {
                        that.providerName = 'Bankrate Rate';
                    }
                    if (that.providerName) {
                        that.$eventBus.$emit('ga', { el: that.providerName.replace(/(\s)+/g, '_') + '_Returned', props: { link_name: result.length } });
                    }
                } else {
                    if (that.mortgageOptions.ltv - 20 > 0) {
                        var tryOption = Object.assign({}, that.mortgageOptions);
                        tryOption.ltv = tryOption.ltv - 20;
                        that.getMortgageInfo(tryOption).then(function (response) {
                            let result = [];
                            if (response) {
                                result = response.rates || [];
                                that.informaDisclaimer = response.disclaimerHtml;
                                that.informaDisclosureContent = response.advertiserDisclosure;
                            }
                            that.mortgageResult = result || [];
                            that.hasChanged = false;
                            that.mortgageRatesLoaded = true;
                            that.completed();
                            if (that.isBankRate) {
                                that.providerName = 'Bankrate Rate';
                            }
                            if (result) {
                                if (that.providerName) {
                                    that.$eventBus.$emit('ga', { el: that.providerName.replace(/(\s)+/g, '_') + '_Returned', props: { link_name: result.length } });
                                }
                            } else {
                                that.$eventBus.$emit('ga', { en: 'rate_api_call', ec: 'Rate_API_Results', el: 'No Rates Returned', props: { link_name: 0 } });
                            }
                        });
                    }
                }
            });
        },
        reset() {
            let values = propertyFuncs.getDppSectionPreferences('paymentCalcValues');
            if (values) {
                if (values['downpaymentRate']) {
                    this.downpaymentRate = Math.min(values['downpaymentRate'], 100);
                } else if (values['downpaymentEquity']) {
                    this.downpaymentEquity = Math.min(this.dpp.price, values['downpaymentEquity']);
                }

                if (values['interestRateIndex']) {
                    this.interestRateIndex = values['interestRateIndex'];
                }
                if (values['interestRate']) {
                    this.interestRate = values['interestRate'];
                }
            }
            this.homePrice = this.showEstPrice() ? this.getEstPrice : this.price;
            this.homeInsurance = Math.round((this.homePrice / 2000) * 3.5);
            this.propertyHoafee = this.hoafee;
            this.downpayment = Math.round((this.homePrice * this.downpaymentRate) / 100) - this.downpaymentEquity;
            this.propertyTaxRate = taxRateByState[this.state] || 0;
            this.interestRate = values && values['interestRate'] ? values['interestRate'] : this.interestOption ? this.interestOption.interestRate : 0;
            this.propertyTax = Math.round((this.homePrice * this.propertyTaxRate) / 100);
            this.algothrim();
        },
        showEstPrice() {
            let isListPriceHigher = this.dpp.listingByMovoto ? this.dpp.price < this.getEstPrice : true;
            return this.dpp.showAsPR && this.dpp.permitAvm && this.getEstPrice && isListPriceHigher;
        },
        calPMI(loanRate, loanYear) {
            if (loanRate >= 0.9001 && loanRate <= 1 && loanYear === 30) {
                return 0.0062;
            }
            if (loanRate >= 0.9001 && loanRate <= 1 && loanYear === 20) {
                return 0.005867;
            }
            if (loanRate >= 0.9001 && loanRate <= 1 && loanYear === 15) {
                return 0.0057;
            }
            if (loanRate >= 0.8501 && loanRate <= 0.9 && loanYear === 30) {
                return 0.0044;
            }
            if (loanRate >= 0.8501 && loanRate <= 0.9 && loanYear === 20) {
                return 0.004067;
            }
            if (loanRate >= 0.8501 && loanRate <= 0.9 && loanYear === 15) {
                return 0.0039;
            }
            if (loanRate >= 0.8 && loanRate <= 0.85 && loanYear === 30) {
                return 0.0027;
            }
            if (loanRate >= 0.8 && loanRate <= 0.85 && loanYear === 20) {
                return 0.002367;
            }
            if (loanRate >= 0.8 && loanRate <= 0.85 && loanYear === 15) {
                return 0.0022;
            }
            return 0;
        },
        updateTaxRate(val) {
            this.hasTaxValChanged = val;
            if (val) {
                if (this.propertyTax >= this.homePrice) {
                    this.propertyTaxRate = 100;
                } else if (this.propertyTax <= 0) {
                    this.propertyTaxRate = 0;
                } else {
                    this.propertyTaxRate = (this.homePrice && this.round((this.propertyTax * 100) / this.homePrice, 2)) || 0;
                }
            } else {
                this.propertyTaxRate = this.propertyTaxRate > 100 ? 100 : this.propertyTaxRate;
            }
            this.algothrim();
        },
        updateDownPayment(val) {
            this.hasDPChanged = val;
            if (val) {
                if (this.downpayment >= this.homePrice) {
                    this.downpaymentRate = !this.downpaymentEquity ? 100 : this.downpaymentRate;
                } else if (this.downpayment <= 0 && !this.downpaymentEquity) {
                    this.downpaymentRate = 0;
                } else {
                    this.downpayment = this.downpaymentEquity >= this.homePrice ? 0 : this.downpayment;
                    this.downpaymentRate = (this.homePrice && this.round(((this.downpayment + this.downpaymentEquity) * 100) / this.homePrice, 2)) || 0;
                }
            } else {
                this.downpaymentRate = this.downpaymentRate > 100 ? 100 : this.downpaymentRate;
                this.downpayment = this.downpaymentEquity >= this.homePrice ? 0 : (this.homePrice * this.downpaymentRate) / 100;
            }
            this.updatePaymentCalcValues('downpaymentRate', this.downpaymentRate);
            this.updatePaymentCalcValues('downpaymentEquity', this.downpaymentEquity);
            this.emitEquityInput && this.downpaymentEquity && this.$eventBus.$emit('ga', { ec: 'propertyMortgage', en: 'focus', el: 'first_focus', props: { link_name: 'equity' } });
            if (this.downpaymentEquity) this.emitEquityInput = false;
            this.algothrim();
        },
        updateInterstRate() {
            const mortgagePerioMapping = {
                PERIOD_FIXED_30YEARS: 'FRM-30',
                PERIOD_FIXED_15YEARS: 'FRM-15',
                PERIOD_ARM_5YEARS: 'ARM-51',
            };
            if (this.updatedMortgateInterestRates && this.updatedMortgateInterestRates[mortgagePerioMapping[this.interestOption.period]]) {
                this.interestRate = this.updatedMortgateInterestRates[mortgagePerioMapping[this.interestOption.period]];
            } else {
                this.interestRate = this.interestOption ? this.interestOption.interestRate : 0;
            }
            this.updatePaymentCalcValues('interestRate', this.interestRate);
            this.updatePaymentCalcValues('interestRateIndex', this.interestRateIndex);

            this.algothrim();
        },
        updatePaymentCalcValues(key, value) {
            this.updateStorage('paymentCalcValues', key, value);
        },
        updatePaymentSectionValues(key, value) {
            this.updateStorage('paymentCalc', key, value);
        },
        updateStorage(sectionName, key, value) {
            if (!sectionName || !key) return;
            let data = {
                section: sectionName,
                details: [{ key: key, value: value }],
            };
            propertyFuncs.setDppSectionPreferences(data);
        },
        isValidPropertyType(propertyType) {
            return !['LAND', 'MOBILE'].includes(propertyType);
        },
        checkData() {
            if (this.downpayment > this.homePrice) {
                this.downpayment = this.homePrice;
                this.downpaymentEquity = 0;
            }
            if (this.propertyTax > this.homePrice) {
                this.propertyTax = this.homePrice;
            }
        },
        round(value, decimals) {
            return Number(Math.round(value + 'e' + decimals) + 'e-' + decimals);
        },
        algothrim() {
            //input
            this.checkData();
            let result = getMonthPay({
                homePrice: this.homePrice,
                downpayment: this.downpayment,
                downpaymentRate: this.downpaymentRate,
                downpaymentEquity: this.downpaymentEquity,
                propertyTax: this.propertyTax,
                propertyTaxRate: this.propertyTaxRate,
                propertyHoafee: this.propertyHoafee,
                interestRate: this.interestRate,
                homeInsurance: this.homeInsurance,
                loanYear: this.interestOption ? this.interestOption.loanYear : 0,
                hasDPChanged: this.hasDPChanged,
                hasTaxValChanged: this.hasTaxValChanged,
                hasPropertyTax: this.hasPropertyTax,
                hasHOADues: this.hasHOADues,
            });

            // output
            this.downpayment = result.downpayment;
            this.propertyTax = result.propertyTax;
            this.ltv = result.ltv;
            this.loanAmount = result.loanAmount;
            this.loanPerMonth = result.loanPerMonth;
            this.taxPerMonth = result.taxPerMonth;
            this.hoaPerMonth = result.hoaPerMonth;
            this.pmiPerMonth = result.pmiPerMonth;
            this.homeInsurancePerMonth = result.homeInsurancePerMonth;
            this.monthTotal = result.monthTotal;
            this.createLoanDescription();
            this.updatePaymentCalcValues('interestRate', this.interestRate);
            this.hasDPChanged = false;
            this.hasTaxValChanged = false;
        },
        createLoanDescription() {
            var options = [];
            this.pricePerMonth && options.push(`$${format.formatNumberByComma(this.pricePerMonth)}/Mo`);
            this.interestOption && options.push(this.interestOption.text.replace(' Years', 'Yr'), `${this.interestRate}% Interest`);
            this.downpaymentRate && options.push(`${this.downpaymentRate}% Down`);
            this.$emit('loanDescription', options.join(', '));
        },
        async showForm(obj) {
            if (!obj) {
                console.error('Invalid obj provided to showForm');
                return;
            }
            const cta = obj.cta;
            const TREATMENT_EXPERIMENT = 'movoto-cpc-lender-cw-9242';
            const TREATMENT_CONFIG = {
                on12: {
                    utm_campaign: 'findlender_sub100',
                    cta: cta,
                    ga: 'partner_mortgage_listings_session_sub100k',
                },
                on13: {
                    utm_campaign: 'Find Lender_inactive',
                    cta: cta,
                    ga: 'partner_mortgage_listings_session',
                    desc: 'findlender',
                },
                on6: {
                    utm_campaign: 'findalender',
                    cta: cta,
                    ga: 'partner_mortgage_listings_session',
                    desc: 'findlender',
                },
                on10: {
                    utm_campaign: 'findalender3T',
                    ga: 'partner_mortgage_listings_session',
                    cta: cta,
                    desc: 'findlender',
                },
            };

            try {
                const treatment = await this.split.fetchTreatments([TREATMENT_EXPERIMENT], {
                    attributes: {
                        movoto_geo_zipcode: this.dpp?.geo?.zipcode,
                        movoto_geo_state: this.dpp?.geo?.state,
                        movoto_listing_price: this.dpp?.price,
                        movoto_listing_type: this.dpp?.propertyType,
                        movoto_listing_status: this.dpp?.houseRealStatus,
                    },
                });

                const treatmentKey = treatment[TREATMENT_EXPERIMENT];
                const opt = TREATMENT_CONFIG[treatmentKey];

                if (opt?.utm_campaign && opt?.ga && opt?.cta) {
                    this.$eventBus.$emit('dialog-center', {
                        name: 'mrcMortgageRates',
                        trigger: this.$options.name,
                        opt: {
                            showNormalMrc: true,
                            ...opt,
                        },
                    });
                    return;
                }
                if (this.getSplit(TREATMENT_EXPERIMENT, 'on15')) {
                    obj.utmcta = 'findalender';
                }
                this.show3rdPartyForm(obj.utmcta, obj.url, cta);
            } catch (error) {
                console.error('Error in showForm:', error);
                this.show3rdPartyForm(obj.utmcta, obj.url, cta);
            }
        },

        show3rdPartyForm(id, url, cta = '', isAppendUtmCta = false, evt) {
            const resolvedCta = resolveClickCta(cta, evt, 'CALC');
            if (['lower_veteran_top', 'lower_veteran_bottom'].includes(id)) {
                this.$eventBus.$emit('eventbus-pop-3rdparty', {
                    id: id,
                    url: url,
                    zipcode: this.zipcode,
                    propertyType: this.propertyType,
                    price: this.price,
                    houseRealStatus: this.houseRealStatus,
                    trigger: this.$options.name,
                    cta: resolvedCta,
                    listingUrl: (this.path && `${this.glb.appUrl}${this.path}`) || '',
                });
                return;
            }
            if (id == 'getquotes' && this.glb.pageType === 'vdpp') {
                this.$eventBus.$emit('ga', { ec: 'partner', en: 'insurance_session', el: 'insurify', props: { link_name: 'getquotes_dpp' } });
                window.open('https://insurify.com/start/home/partner/ojo/?utm_source=ojo&utm_medium=home&utm_campaign=getquotesdpp', '_blank');
                return;
            }
            let mrcSplit = false;
            if (id === 'findlowrate') {
                mrcSplit = true;
            } else if (id === 'veteranscanafford4' && this.showBankrateVeteranBottom) {
                mrcSplit = true;
            } else if (id === 'veteranseligibility' && this.showBankrateVeteranTop) {
                mrcSplit = true;
            }
            if (mrcSplit) {
                this.$eventBus.$emit('dialog-center', {
                    name: 'mrcMortgageRates',
                    trigger: this.$options.name,
                    opt: {
                        showNormalMrc: true,
                        utm_campaign: mrcSplit.utm_campaign,
                        desc: mrcSplit.desc,
                        cta: resolvedCta,
                        ga: 'partner_mortgage_listings_session',
                    },
                });
                return;
            } else {
                this.$eventBus.$emit('eventbus-pop-3rdparty', {
                    id: id,
                    url: url,
                    zipcode: this.zipcode,
                    propertyType: this.propertyType,
                    price: this.price,
                    houseRealStatus: this.houseRealStatus,
                    trigger: this.$options.name,
                    cta: resolvedCta,
                    listingUrl: (this.path && `${this.glb.appUrl}${this.path}`) || '',
                    isAppendUtmCta: isAppendUtmCta,
                });
            }
        },
        initializeSections() {
            let sections = propertyFuncs.getDppSectionPreferences('paymentCalc');
            if (sections) {
                for (const section in sections) {
                    if (sections[section]) {
                        let ele = $(this.$el).find(`[data-id=${section}]`);
                        if (section == 'mortgage') {
                            this.openMorgage = true;
                        } else if (ele) {
                            ele.parent().addClass('shown');
                        }
                    }
                }
            }
            if (this.getSplit('movoto-dpp-mortgagesec-open-cw-803', 'on')) {
                this.openMorgage = true;
            }
        },
    },
};
